import React from "react";

export default function SQL_FULL_OUTER_JOIN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_FULL_OUTER_JOIN</h1>
      <p>This is the SQL_FULL_OUTER_JOIN component generated from the SQL JSON.</p>
    </div>
  );
}
